<template lang="pug">
  div
    b-row
      b-col.order-md-2(md="4")
        b-card
          b-button(variant="primary", block, @click="new_group_modal=!new_group_modal") Crear grupo
          hr
          .text-help
            alert-circle-icon.icon-md.mr-1
            span Puedes crear tantos grupos para casos como requiera tu organización.
      b-col(md="8")
        b-card(no-body, style="width:100%;")
          b-table.card-table.table-nowrap.mb-0(:items="groups", :fields="fields", responsive, show-empty, hover, @row-clicked="prevUpdate($event)")
            template(v-slot:empty)
              span.text-secondary No hay grupos disponibles
            template(v-slot:cell(name)="data")
              b-link.text-dark(@click="prevUpdate(data.item)") {{ data.item.name }}

    b-modal(v-model="new_group_modal", centered, title="Crear nuevo grupo", cancel-title="Cancelar", ok-title="Crear", ok-variant="primary", @ok="createGroup", @show="resetModal")
      b-container(fluid)
        label Nombre:
        b-form-input.mb-2(v-model="new_group.name" placeholder="Nombre", trim, :state="new_group.name ? null : (new_group.validated ? false : null)")
        label Descripción:
        b-form-input(v-model="new_group.description" placeholder="Descripción", trim)

    b-modal(v-model="update_group_modal", centered, title="Actualizar grupo", cancel-title="Cancelar", ok-title="Actualizar", ok-variant="primary", @ok="updateGroup")
      b-container(fluid)
        label Nombre:
        b-form-input.mb-2(v-model="update_group.name" placeholder="Nombre", trim, :state="update_group.name ? null : (update_group.validated ? false : null)")
        label Descripción:
        b-form-input.mb-2(v-model="update_group.description" placeholder="Descripción", trim)
        label Asignación automática en el grupo
        b-form-checkbox.mb-3(switch, v-model="update_group.smartassign_enabled", size="lg") {{update_group.smartassign_enabled ? 'Habilitada' : 'Deshabilitada'}}
        label Tiempo de reasignación de casos:
        b-form-row
          b-col(cols="auto")
            b-form-group(label="Horas", label-size="sm")
              number-input(v-model="update_group.case_time_out_hours", size="small", controls, inline, center, placeholder="0", :min="0", @change="timeToFloat")
          b-col(cols="auto")
            b-form-group(label="Minutos", label-size="sm")
              number-input(v-model="update_group.case_time_out_minutes", size="small", controls, inline, center, placeholder="0", :min="0", :max="59", @change="timeToFloat")
        b-card.bg-light.text-center.text-sm.mb-0.mt-4
          alert-triangle-icon.icon-sm.mr-2
          span Eliminar grupo no se puede deshacer.
          p.mb-0.mt-2
            b-link.text-danger(@click="deleteGroup(update_group)") Eliminar grupo
</template>

<script>
import { createNamespacedHelpers, mapActions } from 'vuex'
const groupController = createNamespacedHelpers('group')

export default {
  data () {
    return {
      hours: 0,
      minutes: 0,
      groups: [],
      fields: [
        {
          key: 'group_id',
          label: 'ID'
        },
        {
          key: 'name',
          label: 'Nombre'
        },
        {
          key: 'description',
          label: 'Descripción'
        }
      ],
      new_group_modal: false,
      new_group: {
        name: '',
        description: '',
        validated: false
      },
      update_group_modal: false,
      update_group: {
        name: '',
        description: '',
        validated: false
      }
    }
  },
  methods: {
    ...mapActions(['group/all', 'group/create', 'group/update', 'group/destroy']),
    getGroups () {
      const self = this
      // this.showLoadingScreen()

      this['group/all']({
        account_id: self.$route.params.account_id,
        callback: res => {
          self.hideLoadingScreen()
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.groups = res.resource.map(group => {
              let [hours, minutes] = this.floatToTime(group.case_time_out);
              group.case_time_out_hours = hours
              group.case_time_out_minutes = minutes
              return group
            })
            console.log("grouops" ,this.groups)
          }
        }
      })
    },
    createGroup (bvModalEvt) {
      if (!this.new_group.name) {
        bvModalEvt.preventDefault()
        this.new_group.validated = true
        return
      }

      const self = this
      this['group/create']({
        account_id: self.$route.params.account_id,
        ...self.new_group,
        callback: res => {
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.getGroups()
            self.clearObject(self.new_group)
          }
        }
      })
    },
    prevUpdate (group) {
      this.update_group = Object.assign(this.update_group, group)
      this.update_group_modal = !this.update_group_modal
    },
    floatToTime (value) {
      let hours = Math.floor(value);
      let min = 1 / 60;
      let remain = value - hours;
      remain = min * Math.round(remain / min);
      let minutes = Math.floor(remain * 60);
      return [hours, minutes]
    },
    timeToFloat () {
      const min = this.update_group.case_time_out_minutes / 60

      this.update_group.case_time_out = (this.update_group.case_time_out_hours + min).toFixed(2)
    },
    updateGroup (bvModalEvt) {
      if (!this.update_group.name) {
        bvModalEvt.preventDefault()
        this.update_group.validated = true
        return
      }

      console.log("UPDATE", this.update_group)
      const self = this
      this['group/update']({
        ...self.update_group,
        callback: res => {
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.getGroups()
            self.update_group = {}
          }
        }
      })
    },
    async deleteGroup (group) {
      const self = this
      try {
        const response = await this.$bvModal.msgBoxConfirm('¿Deseas eliminar este grupo? No se puede deshacer.', {
          title: 'Eliminar grupo',
          okVariant: 'danger',
          okTitle: 'Eliminar',
          cancelTitle: 'Cancelar'
        })
        if (response) {
          this['group/destroy']({
            ...group,
            callback: res => {
              if (res.error) {
                self.$message.error(res.error)
              } else {
                self.update_group_modal = false
                self.getGroups()
              }
            }
          })
        }
      } catch (e) {
        console.error(e.message)
      }
    },
    resetModal () {
      this.clearObject(this.new_group)
    }
  },
  mounted () {
    this.getGroups()
  }
}
</script>

<style lang="css" scoped>
</style>
